import React, { Suspense, lazy } from 'react';
import WorkIcon from '@mui/icons-material/Work'; // Update import if you are using MUI v5
import { Loading } from 'react-admin';

const ReportSuiteList = lazy(() => import('./ReportSuiteList'));
const ReportSuiteCreate = lazy(() => import('./ReportSuiteCreate'));
const ReportSuiteEdit = lazy(() => import('./ReportSuiteEdit'));
const ReportSuiteShow = lazy(() => import('./ReportSuiteShow'));

const ReportSuiteConfig = {
  list: (props) => (
    <Suspense fallback={<Loading />}>
      <ReportSuiteList {...props} />
    </Suspense>
  ),
  create: (props) => (
    <Suspense fallback={<Loading />}>
      <ReportSuiteCreate {...props} />
    </Suspense>
  ),
  edit: (props) => (
    <Suspense fallback={<Loading />}>
      <ReportSuiteEdit {...props} />
    </Suspense>
  ),
  show: (props) => (
    <Suspense fallback={<Loading />}>
      <ReportSuiteShow {...props} />
    </Suspense>
  ),
  icon: <WorkIcon />,
  // options: {
  //     label: 'Master Customer',
  //     items: true
  // }
};

export default ReportSuiteConfig;
